var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.473 14.1143C23.473 13.2858 22.8014 12.6143 21.973 12.6143C21.1446 12.6143 20.473 13.2858 20.473 14.1143H23.473ZM20.473 29.1285C20.473 29.9569 21.1446 30.6285 21.973 30.6285C22.8014 30.6285 23.473 29.9569 23.473 29.1285H20.473ZM14.6133 20.1214C13.7849 20.1214 13.1133 20.7929 13.1133 21.6214C13.1133 22.4498 13.7849 23.1214 14.6133 23.1214V20.1214ZM28.8921 23.1214C29.7205 23.1214 30.3921 22.4498 30.3921 21.6214C30.3921 20.7929 29.7205 20.1214 28.8921 20.1214V23.1214ZM20.473 14.1143V21.6214H23.473V14.1143H20.473ZM20.473 21.6214V29.1285H23.473V21.6214H20.473ZM21.973 20.1214H14.6133V23.1214H21.973V20.1214ZM14.6133 23.1214H28.8921V20.1214H14.6133V23.1214Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7539,
    cy: 21.6211,
    r: 20.1934,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "2.5 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9422 2.10563C30.591 3.07568 33.8948 5.04924 36.4785 7.80229C39.0622 10.5553 40.8223 13.9776 41.5591 17.6805C42.2958 21.3835 41.9797 25.2189 40.6466 28.7512C39.3135 32.2836 37.0167 35.3715 34.0171 37.6643C31.0175 39.9572 27.4352 41.3632 23.6768 41.7227C19.9184 42.0822 16.1345 41.3809 12.7546 39.6983C9.37476 38.0157 6.53427 35.4193 4.55565 32.2037C2.57702 28.9881 1.5395 25.2823 1.56087 21.5068L1.58713 21.5069C1.56579 25.2775 2.60195 28.9786 4.57801 32.1899C6.55406 35.4013 9.39085 37.9944 12.7663 39.6748C16.1418 41.3552 19.9208 42.0556 23.6743 41.6965C27.4278 41.3375 31.0055 39.9333 34.0012 37.6434C36.9969 35.3536 39.2906 32.2697 40.622 28.742C41.9534 25.2142 42.2691 21.3838 41.5333 17.6857C40.7975 13.9875 39.0397 10.5697 36.4593 7.82026C33.879 5.07079 30.5795 3.09979 26.9354 2.131L26.9422 2.10563Z",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusShow);
export default __webpack_public_path__ + "static/media/PlusShow.4ef9b1dbadf6c7d56777c662956ab1a0.svg";
export { ForwardRef as ReactComponent };